import React, { useEffect, useState } from 'react';
import { getRateLimitUntil, RATE_LIMIT_EVENT, rateLimitMessage } from '../utils/rateLimit';

/** One notice across all screens; concurrent 429s update it instead of stacking alerts. */
export default function RateLimitNotice() {
  const [until, setUntil] = useState(getRateLimitUntil);
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    const onLimited = (event: Event) => {
      setUntil((event as CustomEvent<number>).detail);
      setNow(Date.now());
    };
    window.addEventListener(RATE_LIMIT_EVENT, onLimited);
    return () => window.removeEventListener(RATE_LIMIT_EVENT, onLimited);
  }, []);
  useEffect(() => {
    if (!until) return;
    const timer = window.setInterval(() => {
      const current = Date.now();
      setNow(current);
      if (current >= until) window.clearInterval(timer);
    }, 1000);
    return () => window.clearInterval(timer);
  }, [until]);
  if (!until) return null;
  const remaining = Math.max(0, Math.ceil((until - now) / 1000));
  return (
    <div role="status" className="fixed bottom-4 left-4 right-4 z-[100] mx-auto max-w-xl rounded-xl border border-amber-300 bg-amber-50 p-4 text-sm text-amber-950 shadow-lg">
      <div className="flex items-start gap-4">
        <p className="flex-1">{remaining ? rateLimitMessage(remaining) : 'Bekleme süresi doldu. İşleminizi tekrar deneyebilirsiniz.'}</p>
        <button type="button" aria-label="Uyarıyı kapat" onClick={() => setUntil(0)}>Kapat</button>
      </div>
    </div>
  );
}
